import React from 'react';

// Round Details row icons, ported from startup-web's rounds/ViewRound/RoundDetails.js.
// Each gradient (and the outer tile border) uses a per-instance id via useId, so the
// same icon rendered twice on a page (e.g. CalendarIcon for Start + Closing Date)
// can't share/clobber gradient ids. Presentation only.
const STOPS = (
  <>
    <stop stopColor="#7852F8" />
    <stop offset="1" stopColor="#84AEF6" />
  </>
);

// Pencil edit mark (black) for the Secondary Edit button.
export const EditIcon = ({ style }) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M2.5 12.5H5L11.25 6.25L8.75 3.75L2.5 10V12.5Z" stroke="black" strokeWidth="1.1875" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 3.75L11.25 6.25" stroke="black" strokeWidth="1.1875" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RoundNameIcon = () => {
  const uid = React.useId();
  const g = (n) => `roundName_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M10.875 18L18 10.875H22.75C23.1699 10.875 23.5727 11.0418 23.8696 11.3387C24.1665 11.6357 24.3333 12.0384 24.3333 12.4583V17.2083L17.2083 24.3333L10.875 18Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.5626 15.5458C22.1747 15.5458 22.6709 15.0496 22.6709 14.4375C22.6709 13.8254 22.1747 13.3292 21.5626 13.3292C20.9504 13.3292 20.4542 13.8254 20.4542 14.4375C20.4542 15.0496 20.9504 15.5458 21.5626 15.5458Z" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="17.6042" y1="10.875" x2="17.6042" y2="24.3333" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="21.5626" y1="13.3292" x2="21.5626" y2="15.5458" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const RoundTypeIcon = () => {
  const uid = React.useId();
  const g = (n) => `roundType_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M18 10.875L25.125 14.8333L18 18.7917L10.875 14.8333L18 10.875Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.875 18.7917L18 22.75L25.125 18.7917" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path opacity="0.5" d="M10.875 21.9583L18 25.125L25.125 21.9583" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10.875" x2="18" y2="18.7917" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="18" y1="18.7917" x2="18" y2="22.75" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="18" y1="21.9583" x2="18" y2="25.125" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const SecurityTypeIcon = () => {
  const uid = React.useId();
  const g = (n) => `security_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M18 10.875L24.3333 13.25V18C24.3333 21.9583 21.5625 24.3333 18 25.125C14.4375 24.3333 11.6666 21.9583 11.6666 18V13.25L18 10.875Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10.875" x2="18" y2="25.125" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const TotalRoundSizeIcon = () => {
  const uid = React.useId();
  const g = (n) => `totalSize_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M14.8333 14.8333L13.8833 12.4583C13.8311 12.3388 13.8093 12.2083 13.8197 12.0784C13.8301 11.9485 13.8724 11.8231 13.9429 11.7134C14.0134 11.6038 14.1098 11.5132 14.2237 11.4498C14.3376 11.3864 14.4654 11.3521 14.5958 11.35H21.4041C21.5345 11.3521 21.6622 11.3864 21.7761 11.4498C21.89 11.5132 21.9865 11.6038 22.057 11.7134C22.1275 11.8231 22.1698 11.9485 22.1802 12.0784C22.1906 12.2083 22.1688 12.3388 22.1166 12.4583L21.1666 14.8333" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.6458 14.8334H22.3541C23.4625 16.2584 24.3333 18.2375 24.3333 20.375C24.3333 23.0667 22.4333 24.3334 18 24.3334C13.5666 24.3334 11.6666 23.0667 11.6666 20.375C11.6666 18.2375 12.5375 16.2584 13.6458 14.8334Z" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 17.6041V21.5625M17.05 18.6333H18.6333C18.8643 18.6333 19.0858 18.725 19.2491 18.8884C19.4124 19.0517 19.5042 19.2732 19.5042 19.5041C19.5042 19.7351 19.4124 19.9566 19.2491 20.1199C19.0858 20.2832 18.8643 20.375 18.6333 20.375H17.3667C17.1357 20.375 16.9142 20.4667 16.7509 20.63C16.5876 20.7933 16.4958 21.0148 16.4958 21.2458C16.4958 21.4768 16.5876 21.6983 16.7509 21.8616C16.9142 22.0249 17.1357 22.1166 17.3667 22.1166H18.95" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="17.9999" y1="11.35" x2="17.9999" y2="14.8333" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="18" y1="14.8334" x2="18" y2="24.3334" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="18" y1="17.6041" x2="18" y2="22.1166" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const ValuationFloorIcon = () => {
  const uid = React.useId();
  const g = (n) => `floor_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M14.0417 17.2084H13.25C12.8128 17.2084 12.4584 17.5628 12.4584 18V22.75C12.4584 23.1873 12.8128 23.5417 13.25 23.5417H14.0417C14.4789 23.5417 14.8334 23.1873 14.8334 22.75V18C14.8334 17.5628 14.4789 17.2084 14.0417 17.2084Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.7917 13.25H18C17.5628 13.25 17.2084 13.6044 17.2084 14.0417V22.75C17.2084 23.1872 17.5628 23.5417 18 23.5417H18.7917C19.2289 23.5417 19.5834 23.1872 19.5834 22.75V14.0417C19.5834 13.6044 19.2289 13.25 18.7917 13.25Z" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.5417 18.7916H22.75C22.3128 18.7916 21.9584 19.1461 21.9584 19.5833V22.75C21.9584 23.1872 22.3128 23.5416 22.75 23.5416H23.5417C23.9789 23.5416 24.3334 23.1872 24.3334 22.75V19.5833C24.3334 19.1461 23.9789 18.7916 23.5417 18.7916Z" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="13.6459" y1="17.2084" x2="13.6459" y2="23.5417" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="18.3959" y1="13.25" x2="18.3959" y2="23.5417" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="23.1459" y1="18.7916" x2="23.1459" y2="23.5416" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const ValuationCapIcon = () => {
  const uid = React.useId();
  const g = (n) => `cap_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M18 18V10.875C16.5908 10.875 15.2133 11.2929 14.0416 12.0758C12.8699 12.8587 11.9566 13.9715 11.4174 15.2734C10.8781 16.5753 10.737 18.0079 11.0119 19.39C11.2868 20.7721 11.9654 22.0417 12.9619 23.0381C13.9583 24.0346 15.2279 24.7132 16.61 24.9881C17.9921 25.263 19.4247 25.1219 20.7266 24.5826C22.0285 24.0434 23.1413 23.1301 23.9242 21.9584C24.7071 20.7867 25.125 19.4092 25.125 18H18Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.95 10.35C21.3645 10.6134 22.6661 11.299 23.6835 12.3164C24.701 13.3338 25.3865 14.6354 25.65 16.05H19.95V10.35Z" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10.875" x2="18" y2="25.125" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="22.8" y1="10.35" x2="22.8" y2="16.05" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const MinimumChequeIcon = () => {
  const uid = React.useId();
  const g = (n) => `cheque_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M23.5417 12.4584H12.4583C11.5839 12.4584 10.875 13.1673 10.875 14.0417V21.9584C10.875 22.8328 11.5839 23.5417 12.4583 23.5417H23.5417C24.4161 23.5417 25.125 22.8328 25.125 21.9584V14.0417C25.125 13.1673 24.4161 12.4584 23.5417 12.4584Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.875 16.0209H25.125" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.0416 19.5834H17.2083" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="12.4584" x2="18" y2="23.5417" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="18" y1="16.0209" x2="18" y2="17.0209" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="15.625" y1="19.5834" x2="15.625" y2="20.5834" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const TermSheetIcon = () => {
  const uid = React.useId();
  const g = (n) => `term_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M14.0417 10.875H19.5833L22.75 14.0417V24.3333C22.75 24.5433 22.6666 24.7447 22.5181 24.8931C22.3697 25.0416 22.1683 25.125 21.9583 25.125H14.0417C13.8317 25.125 13.6303 25.0416 13.4819 24.8931C13.3334 24.7447 13.25 24.5433 13.25 24.3333V11.6667C13.25 11.4567 13.3334 11.2553 13.4819 11.1069C13.6303 10.9584 13.8317 10.875 14.0417 10.875Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.5834 10.875V14.0417H22.75" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.625 18.7916H20.375M15.625 21.1666H18.7917" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10.875" x2="18" y2="25.125" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="21.1667" y1="10.875" x2="21.1667" y2="14.0417" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="18" y1="18.7916" x2="18" y2="21.1666" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const CommittedFundingIcon = () => {
  const uid = React.useId();
  const g = (n) => `committed_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M14.0417 10.875H19.5833L22.75 14.0417V24.3333C22.75 24.5433 22.6666 24.7447 22.5181 24.8931C22.3697 25.0416 22.1683 25.125 21.9583 25.125H14.0417C13.8317 25.125 13.6303 25.0416 13.4819 24.8931C13.3334 24.7447 13.25 24.5433 13.25 24.3333V11.6667C13.25 11.4567 13.3334 11.2553 13.4819 11.1069C13.6303 10.9584 13.8317 10.875 14.0417 10.875Z" stroke={`url(#${g(1)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.5834 10.875V14.0417H22.75" stroke={`url(#${g(2)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.8625 19.9L17.2875 21.325L19.9792 18.475" stroke={`url(#${g(3)})`} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10.875" x2="18" y2="25.125" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="21.1667" y1="10.875" x2="21.1667" y2="14.0417" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="17.9209" y1="18.475" x2="17.9209" y2="21.325" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const ExitHighlightIcon = () => {
  const uid = React.useId();
  const g = (n) => `exit_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M19 12H13V23H19" stroke={`url(#${g(1)})`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 17.5H24" stroke={`url(#${g(2)})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 14.5L24 17.5L21 20.5" stroke={`url(#${g(3)})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="11.5" y1="14.75" x2="20.7484" y2="19.7946" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="14" y1="17.75" x2="14.2462" y2="19.7192" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="20.25" y1="16" x2="25.05" y2="18.4" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const ClockIcon = () => {
  const uid = React.useId();
  const g = (n) => `clock_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <circle cx="17.5" cy="17.5" r="6.2" stroke={`url(#${g(1)})`} strokeWidth="1.6" />
      <path d="M17.5 14V17.7L20.4 19" stroke={`url(#${g(2)})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="7" y1="14" x2="21" y2="28" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="16.775" y1="15.25" x2="21.115" y2="17.7672" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const CalendarIcon = () => {
  const uid = React.useId();
  const g = (n) => `calendar_${uid}_${n}`;
  return (
    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="11.75" y="13.25" width="11.5" height="10.5" rx="1.25" stroke={`url(#${g(0)})`} strokeWidth="1.5" />
      <path d="M11 16H24" stroke={`url(#${g(1)})`} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 11V14" stroke={`url(#${g(2)})`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5 11V14" stroke={`url(#${g(3)})`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="0.5" y="1.5" width="35" height="35" rx="8.5" stroke={`url(#${g(4)})`} />
      <defs>
        <linearGradient id={g(0)} x1="7.75" y1="15.5" x2="19.7117" y2="28.4585" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="7.75" y1="16.25" x2="7.90294" y2="18.2382" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="14.25" y1="11.75" x2="16.05" y2="12.35" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="20.25" y1="11.75" x2="22.05" y2="12.35" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(4)} x1="18" y1="1" x2="18" y2="37" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const NetBurnIcon = () => {
  const uid = React.useId();
  const g = (n) => `netburn_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path d="M15.1594 14.3334L14.2094 11.9584C14.1573 11.839 14.1354 11.7085 14.1458 11.5785C14.1562 11.4486 14.1986 11.3232 14.269 11.2136C14.3395 11.1039 14.436 11.0134 14.5499 10.9499C14.6638 10.8865 14.7916 10.8522 14.9219 10.8501H21.7303C21.8606 10.8522 21.9884 10.8865 22.1023 10.9499C22.2162 11.0134 22.3127 11.1039 22.3832 11.2136C22.4537 11.3232 22.496 11.4486 22.5064 11.5785C22.5168 11.7085 22.4949 11.839 22.4428 11.9584L21.4928 14.3334" stroke={`url(#${g(1)})`} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.9718 14.3334H22.6802C23.7885 15.7584 24.6593 17.7375 24.6593 19.875C24.6593 22.5667 22.7593 23.8334 18.326 23.8334C13.8927 23.8334 11.9927 22.5667 11.9927 19.875C11.9927 17.7375 12.8635 15.7584 13.9718 14.3334Z" stroke={`url(#${g(2)})`} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.3261 15.7727V21.8182M20.0412 16.9545H17.4566C17.1395 16.9545 16.8353 17.0599 16.6111 17.2474C16.3869 17.435 16.2609 17.6893 16.2609 17.9545C16.2609 18.2197 16.3869 18.4741 16.6111 18.6616C16.8353 18.8492 17.1395 18.9545 17.4566 18.9545H19.1957C19.5128 18.9545 19.8169 19.0599 20.0412 19.2474C20.2654 19.435 20.3914 19.6893 20.3914 19.9545C20.3914 20.2197 20.2654 20.4741 20.0412 20.6616C19.8169 20.8492 19.5128 20.9545 19.1957 20.9545H16.2609" stroke={`url(#${g(3)})`} strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="18.3261" y1="10.8501" x2="18.3261" y2="14.3334" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="18.326" y1="14.3334" x2="18.326" y2="23.8334" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(3)} x1="18.3261" y1="15.7727" x2="18.3261" y2="20.9545" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};

export const RoundStatusIcon = () => {
  const uid = React.useId();
  const g = (n) => `status_${uid}_${n}`;
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <circle cx="17.5" cy="17.5" r="6.2" stroke={`url(#${g(1)})`} strokeWidth="1.6" />
      <path d="M14 17.5L16.5 20L21 15" stroke={`url(#${g(2)})`} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(1)} x1="7" y1="14" x2="21" y2="28" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
        <linearGradient id={g(2)} x1="12.25" y1="16.25" x2="16.9797" y2="22.8716" gradientUnits="userSpaceOnUse">{STOPS}</linearGradient>
      </defs>
    </svg>
  );
};
